import React, { FC } from 'react';
import { Loader } from './Loader';
import styles from './loader_with_text.module.scss';

type Props = {
  color?: string;
};

export const LoaderWithText: FC<Props> = ({ children, color = '#616161' }) => (
  <div className={styles.container}>
    <Loader color={color} />
    <span className={styles.text}>{children}</span>
  </div>
);
